// src/pages/Pricing.jsx
import { useTranslation } from 'react-i18next';
import { useInitialData } from '../components/data/DataContext';
import SeoHead from '../seo/seoHead';
import PurchaseMembershipBlockPricingPage from '../pages/payment/PurchaseMembershipBlockPricingPage';
import PlansExtraInfo from '../pages/payment/planExtraInfo';

const Pricing = () => {
  const { t } = useTranslation();
  const { seo = {} } = useInitialData();

  const {
    title,
    description,
    canonicalUrl,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    ogType,
    twitterCard,
    alternates,
    jsonLd,
    lang,
  } = seo;

  return (
    <>
      <SeoHead
        lang={lang || 'en'}
        title={title}
        description={description}
        canonicalUrl={canonicalUrl}
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogImage={ogImage}
        ogUrl={ogUrl}
        ogType={ogType}
        twitterCard={twitterCard}
        alternates={alternates}
        jsonLd={jsonLd}
      />
      <div className="mx-auto pt-12">
        <div className="flex flex-col items-center">
          <h1 className="text-4xl font-bold mb-4">{t('pagePricing.content.h2')}</h1>
          <PurchaseMembershipBlockPricingPage />
        </div>
      </div>
      <PlansExtraInfo />
    </>
  );
};

export default Pricing;
